module.exports = __webpack_public_path__ + "img/avatar2.7a2e41c4.png";